import InputComponent from './components/InputComponents';
export default InputComponent;
